/** Share of `part` in `whole` as '12.3%'; '—' when there is no whole. */
export function pct(part: number, whole: number): string {
  if (!whole) return '—';
  return `${((part / whole) * 100).toFixed(1)}%`;
}

/**
 * Lift of a came-back rate over the holdout's, in percentage points
 * ('+1.2 pp'); '—' when either side has no players.
 */
export function liftPoints(
  part: number,
  whole: number,
  holdoutPart: number,
  holdoutWhole: number
): string {
  if (!whole || !holdoutWhole) return '—';
  const diff = (part / whole - holdoutPart / holdoutWhole) * 100;
  const rounded = Math.round(diff * 10) / 10;
  return `${rounded > 0 ? '+' : ''}${rounded.toFixed(1)} pp`;
}

/**
 * The count a came-back rate is taken over: delivered pushes for a push arm,
 * but players for a holdout arm (nothing is delivered to them).
 */
export const rateBase = (
  holdout: boolean,
  counts: { delivered: number; selected?: number; players?: number }
): number => (holdout ? (counts.selected ?? counts.players ?? 0) : counts.delivered);
